import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function WhatsAppFloat() {
  const { config } = useSite();
  const number = config?.whatsapp || "5547999999999";
  const msg = encodeURIComponent("Olá! Vim pelo site da Global Refrigeração e gostaria de mais informações.");
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] px-4 py-3 font-bold text-white shadow-lg transition-transform duration-200 hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="hidden sm:inline">Fale no WhatsApp</span>
    </a>
  );
}
